<template>
    <div class="animated fadeIn bookings-page">
        <component-header
            title="Booking Management"
            :hasSearch="true"
            :hasCreate="false"
            :hasReload="true"
            @search-query="(val) => (searchQuery = val)"
            @reload-data="reloadData"
        >
        </component-header>
        <b-row class="mb-3">
            <b-col cols="12" md="3">
                <b-form-select
                    v-model="typeFilter"
                    :options="typeOptions"
                    class="filter-select bookings-filter-select w-100"
                />
            </b-col>

            <b-col cols="12" md="3">
                <b-form-select
                    v-model="statusFilter"
                    :options="statusOptions"
                    class="filter-select bookings-filter-select w-100"
                />
            </b-col>

            <b-col cols="12" md="3">
                <b-form-select
                    v-model="cityFilter"
                    :options="cityOptions"
                    class="filter-select bookings-filter-select w-100"
                />
            </b-col>

            <b-col cols="12" md="3">
                <b-form-select
                    v-model="paymentFilter"
                    :options="paymentOptions"
                    class="filter-select bookings-filter-select w-100"
                />
            </b-col>
        </b-row>
        <b-card class="card-wrap" border-variant="info">
            <div class="table-wrapper">
                <b-table
                    id="bookings-table"
                    class="tableRadius professional-stacked-table"
                    :items="filteredBookings"
                    :fields="bookingColumns"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :hover="hover"
                    :striped="striped"
                    :bordered="bordered"
                    :small="small"
                    responsive="sm"
                    stacked="md"
                    thead-class="header"
                    show-empty
                    empty-text="No bookings found."
                >
                    <template #cell(bookingId)="data">
                        <a
                            href="#"
                            class="booking-link"
                            @click.prevent="goToBooking(data.item)"
                        >
                            {{ data.item.bookingId }}
                        </a>
                    </template>

                    <template #cell(amount)="data">
                        <strong>{{ formatAmount(data.item.amount) }}</strong>
                    </template>

                    <template #cell(status)="data">
                        <span
                            class="status-badge"
                            :class="statusClass(data.item.status)"
                        >
                            {{ statusLabel(data.item.status) }}
                        </span>
                    </template>

                    <template #cell(time)="data">
                        <span class="time-text">{{ data.item.time }}</span>
                    </template>

                    <template #cell(action)="data">
                        <div class="inline_btnTable">
                            <b-button
                                size="sm"
                                class="button-circle"
                                variant="primary"
                                @click.stop="goToBooking(data.item)"
                            >
                                <i class="fa fa-eye"></i>
                            </b-button>
                        </div>
                    </template>
                </b-table>
            </div>
            <div class="pagination-wrapper">
                <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="filteredBookings.length"
                    aria-controls="bookings-table"
                    prev-text="Prev"
                    next-text="Next"
                    hide-goto-end-buttons
                ></b-pagination>
            </div>
        </b-card>
    </div>
</template>

<script>
import ComponentHeader from "@/components/componentNewHeader";

export default {
    name: "Bookings",
    components: {
        ComponentHeader,
    },
    data() {
        return {
            searchQuery: "",
            typeFilter: "all",
            statusFilter: "all",
            cityFilter: "all",
            paymentFilter: "all",
            perPage: 10,
            currentPage: 1,
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            bookingColumns: [
                { key: "bookingId", label: "Booking ID", sortable: true },
                { key: "type", label: "Type" },
                { key: "customer", label: "Customer" },
                { key: "driver", label: "Driver" },
                { key: "city", label: "City" },
                { key: "amount", label: "Amount" },
                { key: "status", label: "Status" },
                { key: "payment", label: "Payment" },
                { key: "time", label: "Time", class: "text-right" },
                { key: "action", label: "", thClass: "text-right" },
            ],
            typeOptions: [
                { value: "all", text: "All Types" },
                { value: "Economy - Mini", text: "Economy - Mini" },
                { value: "Economy - Sedan", text: "Economy - Sedan" },
                { value: "Premium - SUV", text: "Premium - SUV" },
                { value: "Premium - XUV", text: "Premium - XUV" },
                { value: "Luxury - Sedan", text: "Luxury - Sedan" },
                { value: "Special - Auto", text: "Special - Auto" },
            ],
            statusOptions: [
                { value: "all", text: "All Status" },
                { value: "completed", text: "Completed" },
                { value: "in-progress", text: "In-progress" },
                { value: "cancelled", text: "Cancelled" },
            ],
            cityOptions: [
                { value: "all", text: "All Cities" },
                { value: "Bangalore", text: "Bangalore" },
                { value: "Hyderabad", text: "Hyderabad" },
                { value: "Chennai", text: "Chennai" },
                { value: "Mumbai", text: "Mumbai" },
            ],
            paymentOptions: [
                { value: "all", text: "All Payment" },
                { value: "UPI", text: "UPI" },
                { value: "Card", text: "Card" },
                { value: "Cash", text: "Cash" },
                { value: "Wallet", text: "Wallet" },
            ],
            bookings: [
                {
                    bookingId: "RB-3847",
                    type: "Economy - Mini",
                    customer: "Rajesh Kumar",
                    driver: "Amit Sharma",
                    city: "Bangalore",
                    amount: 245,
                    status: "completed",
                    payment: "UPI",
                    time: "2:30 PM",
                },
                {
                    bookingId: "RB-3846",
                    type: "Premium - SUV",
                    customer: "Priya Patel",
                    driver: "Vikram Singh",
                    city: "Bangalore",
                    amount: 520,
                    status: "in-progress",
                    payment: "Card",
                    time: "2:25 PM",
                },
                {
                    bookingId: "RB-3845",
                    type: "Economy - Sedan",
                    customer: "Sanjay Reddy",
                    driver: "Mohammed Ansari",
                    city: "Bangalore",
                    amount: 180,
                    status: "in-progress",
                    payment: "Cash",
                    time: "2:22 PM",
                },
                {
                    bookingId: "RB-3844",
                    type: "Luxury - Sedan",
                    customer: "Anjali Mehta",
                    driver: "Suresh Iyer",
                    city: "Bangalore",
                    amount: 680,
                    status: "completed",
                    payment: "Card",
                    time: "2:18 PM",
                },
                {
                    bookingId: "RB-3843",
                    type: "Special - Auto",
                    customer: "Deepak Joshi",
                    driver: "Ravi Kumar",
                    city: "Bangalore",
                    amount: 85,
                    status: "completed",
                    payment: "UPI",
                    time: "2:15 PM",
                },
                {
                    bookingId: "RB-3842",
                    type: "Premium - XUV",
                    customer: "Kavita Deshmukh",
                    driver: "Arjun Pillai",
                    city: "Bangalore",
                    amount: 420,
                    status: "cancelled",
                    payment: "Wallet",
                    time: "2:10 PM",
                },
            ],
        };
    },
    computed: {
        filteredBookings() {
            const searchTerm = (this.searchQuery || "").trim().toLowerCase();
            const searchFields = [
                "bookingId",
                "type",
                "customer",
                "driver",
                "city",
                "payment",
            ];

            return (this.bookings || []).filter((booking) => {
                const matchesSearch =
                    !searchTerm ||
                    searchFields.some((field) =>
                        String(booking[field] || "")
                            .toLowerCase()
                            .includes(searchTerm),
                    );

                const matchesType =
                    this.typeFilter === "all" ||
                    booking.type === this.typeFilter;

                const matchesStatus =
                    this.statusFilter === "all" ||
                    this.normalizeStatus(booking.status) ===
                        this.normalizeStatus(this.statusFilter);

                const matchesCity =
                    this.cityFilter === "all" ||
                    booking.city === this.cityFilter;

                const matchesPayment =
                    this.paymentFilter === "all" ||
                    booking.payment === this.paymentFilter;

                return (
                    matchesSearch &&
                    matchesType &&
                    matchesStatus &&
                    matchesCity &&
                    matchesPayment
                );
            });
        },
    },
    watch: {
        typeFilter() {
            this.currentPage = 1;
        },
        statusFilter() {
            this.currentPage = 1;
        },
        cityFilter() {
            this.currentPage = 1;
        },
        paymentFilter() {
            this.currentPage = 1;
        },
    },
    methods: {
        reloadData() {
            this.searchQuery = "";
            this.typeFilter = "all";
            this.statusFilter = "all";
            this.cityFilter = "all";
            this.paymentFilter = "all";
            this.currentPage = 1;
        },
        
        goToBooking(booking) {
            const id = booking?.bookingId || "";
            if (id) {
                this.$router.push(`/bookings/view/${encodeURIComponent(id)}`);
            }
        },
        normalizeStatus(status) {
            return String(status || "")
                .trim()
                .toLowerCase()
                .replace(/\s+/g, "-");
        },
        statusLabel(status) {
            const normalized = this.normalizeStatus(status);
            const statusMap = {
                "in-progress": "in-progress",
                completed: "completed",
                cancelled: "cancelled",
            };
            return statusMap[normalized] || status || "";
        },
        statusClass(status) {
            const normalized = this.normalizeStatus(status);
            const classMap = {
                completed: "badge-success",
                "in-progress": "badge-info",
                cancelled: "badge-danger",
            };
            return classMap[normalized] || "badge-secondary";
        },
        formatAmount(amount) {
            const num = Number(amount);
            if (Number.isNaN(num)) return "₹0";
            try {
                return new Intl.NumberFormat("en-IN", {
                    style: "currency",
                    currency: "INR",
                    maximumFractionDigits: 0,
                }).format(num);
            } catch {
                return `₹${num}`;
            }
        },
    },
};
</script>

<style scoped>
.bookings-page {
    padding: 8px 0;
}

.card-wrap {
    box-shadow: 0 0 10px #ccc;
    border-radius: 12px;
}

.bookings-filters-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.bookings-filter-select {
    min-width: 140px;
    height: 34px;
    font-size: 14px;
    border-radius: 8px;
}

.bookings-filter-select :deep(select),
.bookings-filter-select :deep(.custom-select) {
    height: 34px !important;
    min-height: 34px !important;
    padding: 0 12px;
    border-radius: 8px;
    border: 1px solid var(--slate-200);
    font-size: 14px;
}

.table-wrapper {
    overflow-x: auto;
    width: 100%;
}

.table-border-radius {
    border-radius: 12px;
    min-width: 100%;
}

::v-deep #bookings-table thead th {
    background-color: var(--slate-50);
    border-bottom: 1px solid rgba(226, 232, 240, 0.5);
    font-weight: 800;
    color: var(--slate-700);
    padding: 16px 18px;
}

::v-deep #bookings-table tbody td {
    padding: 16px 18px;
    vertical-align: middle;
}

/* b-table row clickable */
::v-deep #bookings-table tbody tr {
    cursor: pointer;
}

.booking-link {
    color: var(--info-text);
    text-decoration: none;
}

.booking-link:hover {
    text-decoration: underline;
}

::v-deep #bookings-table .table td strong {
    color: #000;
    font-weight: 800;
}

.inline_btnTable {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
}

.inline_btnTable .button-circle {
    width: 34px;
    height: 34px;
    border-radius: 50% !important;
    padding: 0 !important;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
}

.inline_btnTable .button-circle i {
    margin: 0;
    font-size: 14px;
    line-height: 1;
}

.status-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
    width: 100%
}

.status-badge.badge-success {
    background: var(--success-bg);
    color: var(--success-text);
}

.status-badge.badge-info {
    background: var(--info-bg);
    color: var(--info-text);
}

.status-badge.badge-danger {
    background: var(--danger-bg);
    color: var(--danger-text);
}

.status-badge.badge-secondary {
    background: var(--slate-100);
    color: var(--slate-700);
}

.time-text {
    color: var(--slate-500);
    font-weight: 500;
}

.pagination-wrapper {
    margin-top: 1rem;
    float: right;
}

@media (max-width: 767.98px) {
    .pagination-wrapper {
        float: none;
        text-align: center;
    }
}

@media (max-width: 991.98px) {
    .bookings-filters-wrapper {
        width: 100%;
        justify-content: flex-start;
    }

    .bookings-filter-select {
        flex: 1 1 calc(50% - 8px);
        min-width: 120px;
        margin-bottom: 5px;
    }
}

@media (max-width: 767.98px) {
    .bookings-filter-select {
        flex: 1 1 100%;
        min-width: 100%;
        margin-bottom: 5px;
    }
}
</style>
